import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMt: CultureInfo = {
  name: 'mt',
  displayName: 'Maltese',
  iso3LanguageCode: 'mlt',
  iso2LanguageCode: 'mt',
  ietfLanguageTag: 'mt',
  parent: null
};
